import {configureStore} from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import {reduxBatch} from "@manaflair/redux-batch";
import {persistStore} from "redux-persist";
import {rootReducer, rootSaga} from "./RootReducer";

const sagaMiddleware = createSagaMiddleware();

// Redux Toolkit 2 requires `middleware` and `enhancers` to be callbacks that
// build on the defaults, rather than plain arrays (the old `getDefaultMiddleware`
// standalone export and array forms were removed).
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: true,
    }).concat(sagaMiddleware),
  devTools: process.env.NODE_ENV !== "production",
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(reduxBatch),
});

export type AppDispatch = typeof store.dispatch

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
// redux 5 narrows the store action type to a specific union, which is not
// assignable to redux-persist's expected Store<any, UnknownAction> (action type
// is contravariant). The store is structurally valid; cast to satisfy the types.
export const persistor = persistStore(store as any);

sagaMiddleware.run(rootSaga);

export default store;
